declare global {
    interface Window {
        pageVariables?: PageVariablesInterface;
    }
}

interface PageVariablesInterface {
    apiHost: string;
}

class PageVariables {
    private variables: PageVariablesInterface;

    public constructor() {
        if (!window.pageVariables) {
            throw new Error('window.pageVariables is missing');
        }

        this.variables = window.pageVariables;

        delete window.pageVariables;
    }

    public getApiHost(): string {
        return this.variables.apiHost;
    }
}

export default new PageVariables;
